const SummaryEndpoints = {
  GET_SUMMARY: (analysisId: string, categoryPath: string) => `/analyses/${analysisId}/summaries/${categoryPath}/`,
};

export default SummaryEndpoints;
